module.exports = __webpack_public_path__ + "media/images/icons/bts-0277ec2aef3d36fea7114bd0405e2df2.svg";